<template>
    <el-dialog
        :visible.sync="visible"
        :append-to-body="true"
        :destroy-on-close="true"
        width="900px"
        top="0"
        class="info-notice-box"
        :show-close="false"
        :footer="false"
    >
        <div>
            <div class="modal-header">
              <h3 class="modal-title">让您的能力和资源更有价值</h3>
              <button class="close-btn" aria-label="关闭" @click="closeHandleSubmit">×</button>
            </div>
            <div class="modal-body">
              <p class="intro">
                亲爱的工程师朋友：<br />您可能还没有意识到您具备的能力和资源在大国工匠平台上是可以有收益的，如果您真的希望把自己掌握的能力和资源变现，请务必认真按照下面的操作完善您的信息和身边的资源。
              </p>
              <ol>
                <li>请在大国工匠右上角点击您的头像，完善好您的个人信息。</li>
                <li>请您根据实际情况，真实描述您的专业能力，在个人资料里点击修改技能标签，您的能力越强，越可能会得到更多公司的需求，在别人希望得到您的帮助时，可能会支付报酬。</li>
                <li>请完善好您目前的真实工作单位信息，或者及时更改您的所在单位，准确的信息或可能给您带来更多的资源价值。</li>
              </ol>
              <!-- <div class="warning">
                <svg class="warning-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <span>特别提醒，请及时修正您目前的真实工作单位，以便其他您可能需要的资源方便找到您，并向您支付必要的费用。</span>
              </div> -->
            </div>
            <div class="modal-footer">
              <span class="qrcode-tip">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <rect x="7" y="7" width="4" height="4"></rect>
                      <rect x="13" y="7" width="4" height="4"></rect>
                      <rect x="7" y="13" width="4" height="4"></rect>
                      <rect x="13" y="13" width="4" height="4"></rect>
                  </svg>
                  添加自己的收款码，相互方便
              </span>
              <button class="primary-btn" @click="handleGuide">立即完善</button>
              <button class="secondary-btn" @click="closeHandleSubmit">暂不完善</button>
              <button class="ghost-btn" @click="handleQRCode">添加收款码</button>
          </div>
        </div>
    </el-dialog>
</template>

<script>


export default {
    data() {
        return {
            visible: false,
            domain: 'https://smart3d.global-dsc.cn'
            // domain: 'http://localhost:3001'
        }
    },
    mounted() {
    
    },
   
    methods: {
       close() {
        this.visible = false;
        localStorage.setItem('infoNoticeShown', 'true');
       }, 
       show () {
        // 关闭过不在弹出
        if (localStorage.getItem('infoNoticeShown') === 'true') {
          return;
        }
        this.visible = true;
       },
       closeHandleSubmit() {
        this.close();
       },
       handleGuide() {
        this.close();
        window.open(`${this.domain}/#/account/personalData?activeDggj=skillEdit`);
       },
       handleQRCode() {
        this.close();
        window.open(`${this.domain}/#/account/personalData?activeDggj=qrCode`);
       },
    },
}
</script>   

<style lang="less" scoped>
    .info-notice-box{
        ::v-deep .el-dialog__header{
            padding: 0;
        }
        ::v-deep .el-dialog {
            margin: 0 auto !important;
            top: 0 !important;
        }
        .modal-header {
            background: linear-gradient(105deg, #e0e7ff 0%, #c7d2fe 100%);
            padding: 20px 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        }
        .modal-title {
            font-size: 1.4rem;
            font-weight: 700;
            color: #2b5fea;
            letter-spacing: 0.2px;
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding-left: 10px;
            margin: 0;
        }
        .modal-title::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #3b82f6;
            border-radius: 50%;
            box-shadow: 0 0 12px #3b82f6;
        }
        .close-btn {
            outline: none;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(4px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            cursor: pointer;
            font-size: 1.25rem;
            color: #cbd5e1;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            font-weight: 300;
            &:hover {
            background: rgba(255, 255, 255, 0.25);
            color: #ffffff;
            transform: scale(1.05);
            border-color: rgba(255, 255, 255, 0.4);
            }
        }
        .modal-body {
            padding: 20px;
            padding-top: 10px;
            .intro {
            font-size: 15px;
            color: #334155;
            margin-bottom: 20px;
            line-height: 1.7;
            font-weight: 500;
            background: #f1f5f9;
            padding: 10px 15px;
            border-radius: 10px;
            border-left: 4px solid #3b82f6;
            color: #1e293b;
            }
            ol {
            list-style: none;
            counter-reset: step-counter;
            padding-left: 0;
            }
            li {
            counter-increment: step-counter;
            position: relative;
            padding-left: 3.5rem;
            margin-bottom: 12px;
            font-size: 15px;
            color: #334155;
            line-height: 1.7;
            min-height: 2.5rem;
            display: flex;
            align-items: center;
            
            }
            li::before {
            content: counter(step-counter);
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 2.4rem;
            height: 2.4rem;
            background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
            color: #1e40af;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 15px;
            border: 2px solid #ffffff;
            box-shadow: 0 4px 8px -2px rgba(37, 99, 235, 0.15), 0 0 0 2px rgba(37, 99, 235, 0.1);
            transition: all 0.2s;
            }
            li:hover::before {
            background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%);
            color: #ffffff;
            box-shadow: 0 6px 12px -3px rgba(37, 99, 235, 0.3);
            }
            .warning {
            font-size: 15px;
            background: #fff5f5;
            color: #991b1b;
            padding: 10px 15px;
            border-radius: 1rem;
            border: 1px solid #fecaca;
            font-weight: 500;
            margin-top: 20px;
            display: flex;
            align-items: flex-start;
            gap: 0.75rem;
            box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.05);
            transition: all 0.2s;
            }
            .warning-icon {
                flex-shrink: 0;
                width: 1.25rem;
                height: 1.25rem;
                color: #dc2626;
                margin-top: 0.1rem;
            }
            .warning:hover {
            background: #fef2f2;
            border-color: #f87171;
            }
        }
        .modal-footer {
            padding: 1.5rem 2.5rem;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
            display: flex;
            align-items: center;
            gap: 1rem;
            flex-wrap: wrap;

            .qrcode-tip {
            color: #64748b;
            font-size: 15px;
            font-weight: 500;
            margin-right: auto;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            }
            .primary-btn, .secondary-btn, .ghost-btn {
            padding: 0.75rem 2rem;
            border-radius: 0.75rem;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.25s ease;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            letter-spacing: 0.2px;
            border: none;
            white-space: nowrap;
            outline: none;
            }
            .primary-btn {
            background: linear-gradient(135deg, #347ef6 0%, #2563eb 100%);
            color: #ffffff;
            box-shadow: 0 4px 12px -2px rgba(37, 99, 235, 0.3);
            border: 1px solid rgba(255, 255, 255, 0.1);
            }
            .primary-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 20px -4px rgba(37, 99, 235, 0.4);
            background: linear-gradient(135deg, #1d4ed8 0%, #4338ca 100%);
            }
            .secondary-btn {
            background: #ffffff;
            color: #475569;
            border: 1px solid #cbd5e1;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
            }
            .secondary-btn:hover {
            background: #f1f5f9;
            border-color: #94a3b8;
            color: #1e293b;
            }
            .ghost-btn {
            background: rgba(37, 99, 235, 0.05);
            color: #2563eb;
            border: 1px solid rgba(37, 99, 235, 0.2);
            box-shadow: none;
            }
            .ghost-btn:hover {
            background: rgba(37, 99, 235, 0.1);
            border-color: rgba(37, 99, 235, 0.4);
            transform: translateY(-1px);
            }
        }
  
    }
</style>

<style lang="less">
.info-notice-box {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5555 !important;
}

</style>
